import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import Svg from 'tio-employee/components/svg';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import screenIs from 'tio-common/helpers/screen-is';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import ForgivenessEstimatorForgivenessEstimatorForm from 'tio-employee/components/forgiveness-estimator/forgiveness-estimator-form';
import type { LoanSummary } from 'tio-common/types/loan-summary';

interface S {
  Args: {
    model: {
      // TODO: What is a loan summary? Where does it come from?
      loanSummary: LoanSummary;
    };
  };
}

export default class ForgivenessEstimatorIndexRoute extends Component<S> {
  @service declare router: RouterService;

  didSave = (recommendation: RecommendationModel) => {
    return this.router.transitionTo(
      'authenticated.idr.dashboard.forgiveness-estimator.results',
      recommendation.id
    );
  };

  <template>
    <TioPageBreadcrumbs class="mb-4" as |b|>
      <b.crumb @route="authenticated.idr.dashboard.index" @label="Dashboard" />
      <b.crumb
        @route="authenticated.idr.dashboard.forgiveness-estimator.index"
        @label="Forgiveness Estimator"
      />
    </TioPageBreadcrumbs>
    <div class="tio-flex-center gap-8">
      <ForgivenessEstimatorForgivenessEstimatorForm
        @application="IDR"
        @loanSummary={{@model.loanSummary}}
        @didSave={{this.didSave}}
        class="md:max-w-3xl"
      />
      {{#if (screenIs "lg")}}
        <div class="p-6 mt-9">
          <Svg @name="infographic-screen" role="img" aria-label={{t "svg.infographic_screen"}} />
        </div>
      {{/if}}
    </div>
  </template>
}
